import { render } from "./auth-verify-account.vue?vue&type=template&id=5aa5db1a&ts=true"
import script from "./auth-verify-account.vue?vue&type=script&lang=ts"
export * from "./auth-verify-account.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__